import type {
  InteractiveQuestionAnswerPayload,
  InteractiveQuestionState,
} from '@genially/p2p-lib';

import { toRestorableAnswer } from './toRestorableAnswer';

/**
 * Builds the plain, `postMessage`-safe answers payload `getInitialData` hands to the view.
 *
 * `toRestorableAnswer` is what converts each still-observable `answer` to a plain value — see its
 * own comment for why that has to happen there and not here.
 */
export const getRestorableAnswersForPlayer = (
  interactiveQuestionAnswers: Record<string, InteractiveQuestionState>,
  username: string,
): InteractiveQuestionAnswerPayload[] =>
  Object.values(interactiveQuestionAnswers)
    .flatMap(state => state.playerUserAnswers)
    .filter(playerUserAnswer => playerUserAnswer.player.username === username)
    .map(toRestorableAnswer);
